import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { I18N } from "@/lib/i18n";

const LanguageContext = createContext({
  lang: "es",
  setLang: () => {},
  t: I18N.es,
});

const LS_KEY = "vk_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "es";
    return window.localStorage.getItem(LS_KEY) === "en" ? "en" : "es";
  });

  const setLang = useCallback((next) => {
    if (next !== "es" && next !== "en") return;
    setLangState(next);
    try {
      window.localStorage.setItem(LS_KEY, next);
    } catch (_) {}
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = lang;
    document.title = I18N[lang].seo.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", I18N[lang].seo.description);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: I18N[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useT() {
  return useContext(LanguageContext);
}
